export default `
mutation createShiftTemplate(
  $displayName: String!,
  $templateId: ID!, 
  $time: TimeComponentsInput, 
  $userId: ID,
  $note: String, 
  $requiredLevels: [OfficerLevel],
  $serviceProviderId: ID!,
  $timezone: String!,
  $postOrders: [PostOrderInput!]!
) {
  createShiftTemplate(
    displayName: $displayName,
    templateId: $templateId, 
    time: $time, 
    userId: $userId,
    note: $note,
    requiredLevels: $requiredLevels,
    serviceProviderId: $serviceProviderId,
    timezone: $timezone,
    postOrders: $postOrders
  ) {
    templateId
    displayName
    userId
    time {
      duration
      startHours
      startMinutes
    }
    note
    requiredLevels
    serviceProviderId
    timezone
    postOrders {
      description
      time {
        start
        end
      }
      propertyId
      dar {
        isRequired
        darId
      }
      completed {
        timestamp
        coordinates {
          lat
          lng
        }
      }
    }
  }
}
`;